export const HIDE_CLASS = 'hide';

export function invalidFormFieldLabelPositionHandler(formSelector: string): void {
  const inputs = document.querySelectorAll<HTMLInputElement>(`${formSelector} input`);
  const handler = (e: Event): void => {
    const target = e.target as HTMLInputElement;
    if (target.value === '') {
      target.classList.remove('_has-value');
    } else {
      target.classList.add('_has-value');
    }
  };
  inputs.forEach((input) => ['blur', 'change', 'keyup'].forEach((evt) => input.addEventListener(evt, handler)));
}

export function bindInputServerValidationOnChange(formId: string): void {
  const inputs = document.querySelectorAll<HTMLInputElement>(`${formId} input`);

  inputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      if (target.parentElement?.classList.contains('form-field--error')) {
        target.parentElement?.classList.remove('form-field--error');
        document.querySelectorAll<HTMLElement>(`${formId} .form-msg-error`).forEach((el) => el.remove());
      }
    });
  });
}

export function validateEqualTo(input: HTMLInputElement | HTMLSelectElement): string | null {
  const selector = input.dataset.parsleyEqualTo;

  if (!selector) {
    return null;
  }

  const otherField = document.querySelector<HTMLInputElement>(selector);

  if (otherField && otherField.value === input.value) {
    return null;
  }

  return input?.dataset.parsleyEqualToMessage || "Values don't match";
}

export function validateField(input: HTMLInputElement | HTMLSelectElement, force = false) {
  return (e: Event): void => {
    e.preventDefault();
    let errorHTML;
    const patternErrorMessage = input?.dataset?.patternErrorMessage || '';
    const validationErrorMessage = input?.dataset?.validationErrorMessage || '';
    const requiredErrorMessage = input?.dataset?.fieldRequiredErrorMessage || 'This is a required field'; // TODO: extract it from translations
    const errorsEl = input.parentNode?.querySelector<HTMLUListElement>('ul.errors-list');
    const backEndErrorEl = input
      .closest('.form-field--error')
      ?.parentNode?.querySelector<HTMLUListElement>('.form-msg-error');
    const showRequired = input.hasAttribute('required') && !input.value;
    const validEqualToMessage = validateEqualTo(input);
    if (validEqualToMessage) {
      errorHTML = `<li class=parsley-pattern'>${validEqualToMessage}</li>`;
    } else {
      errorHTML = `<li class='${showRequired ? 'parsley-required' : 'parsley-pattern'}'>${
        showRequired ? requiredErrorMessage : patternErrorMessage || validationErrorMessage
      }</li>`;
    }

    input.closest('.form-field--error')?.classList.remove('form-field--error');

    if (input.validity.valid && !force && !validEqualToMessage) {
      if (errorsEl) {
        errorsEl.remove();
      }
      if (backEndErrorEl) {
        backEndErrorEl.remove();
      }
      input.classList.remove('_is-error');
    } else {
      input.classList.add('_is-error');

      if (!errorsEl) {
        const newErrorsEl = document.createElement<'ul'>('ul');
        newErrorsEl.classList.add('errors-list');
        input.parentElement?.appendChild(newErrorsEl);
        newErrorsEl.innerHTML = errorHTML;
      } else {
        errorsEl.innerHTML = errorHTML;
      }
    }
  };
}

/**
 * TODO: After both pages /register and /my-account/update-profile will have same functionality,
 * please, revert logic in this function to commit: a86889f
 */
export function initNotificationChannelsSelector(): void {
  const notificationCheckboxInput =
    (document.getElementById('receiveMarketingEmails') as HTMLInputElement) ||
    (document.getElementById('communications') as HTMLInputElement);
  const checkboxes = document.querySelectorAll<HTMLInputElement>('.notification-channels__checkbox');
  const notificationChannelsContainer = document.querySelector<HTMLDivElement>('.js-notification-channels-container');
  const birthdayDaySelect = document.querySelector<HTMLSelectElement>('#select-day select');
  const birthdayMonthSelect = document.querySelector<HTMLSelectElement>('#select-month select');

  if (!notificationChannelsContainer) {
    return;
  }

  const notificationAnimation = createAnimation(notificationChannelsContainer);

  notificationCheckboxInput.addEventListener('change', () => {
    checkboxes.forEach((checkbox) => {
      checkbox.checked = notificationCheckboxInput.checked;
    });

    if (notificationCheckboxInput.checked) {
      notificationChannelsContainer.classList.remove(HIDE_CLASS);
      notificationAnimation.expand();
    }

    if (!notificationCheckboxInput.checked) {
      clearBirthdayFields();
      notificationAnimation.collapse(() => notificationChannelsContainer.classList.add(HIDE_CLASS));
    }
  });

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const checkedCheckboxes = document.querySelectorAll('.notification-channels__checkbox:checked');

      if (!checkedCheckboxes.length) {
        notificationCheckboxInput.checked = false;
        notificationCheckboxInput.dispatchEvent(new CustomEvent('change'));
      }
    });
  });

  if (!birthdayDaySelect || !birthdayMonthSelect) {
    return;
  }

  notificationCheckboxInput.addEventListener('change', validateField(birthdayDaySelect));
  notificationCheckboxInput.addEventListener('change', validateField(birthdayMonthSelect));

  const monthOptionsElm = [...birthdayMonthSelect.options];
  const dayOptionsElm = [...birthdayDaySelect.options];
  const availableDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  updateDays();
  updateMonths();

  birthdayDaySelect.addEventListener('change', updateDays);
  birthdayMonthSelect.addEventListener('change', updateMonths);

  function updateDays(): void {
    if (!birthdayDaySelect || !birthdayMonthSelect) {
      return;
    }

    toggleRequired(birthdayMonthSelect, birthdayDaySelect, birthdayDaySelect.value === '');
    clearDisabledState(monthOptionsElm);
    disableUnavailableMonths(parseInt(birthdayDaySelect.value, 10));
  }

  function updateMonths(): void {
    if (!birthdayDaySelect || !birthdayMonthSelect) {
      return;
    }

    toggleRequired(birthdayDaySelect, birthdayMonthSelect, birthdayMonthSelect.value === '');
    clearDisabledState(dayOptionsElm);
    disableUnavailableDays(parseInt(birthdayMonthSelect.value, 10));
  }

  function disableUnavailableDays(selectedMonth: number): void {
    const monthIdx = selectedMonth - 1;
    const maxDaysInMonth = availableDays[monthIdx];

    dayOptionsElm
      .filter((optElm) => +optElm.value > maxDaysInMonth)
      .forEach((optElm) => optElm.setAttribute('disabled', ''));
  }

  function disableUnavailableMonths(selectedDay: number): void {
    monthOptionsElm
      .slice(1)
      .filter((_, i) => selectedDay > availableDays[i])
      .forEach((optElm) => optElm.setAttribute('disabled', ''));
  }

  function clearDisabledState(elmsArray: HTMLOptionElement[]): void {
    elmsArray.filter((opt) => opt.disabled).forEach((opt) => opt.removeAttribute('disabled'));
  }

  function toggleRequired(element: HTMLSelectElement, currentElement: HTMLSelectElement, isEmptyValue: boolean): void {
    if (isEmptyValue) {
      element.removeAttribute('required');
      element.removeEventListener('invalid', validateField(element));
      element.removeEventListener('change', validateField(element));
      currentElement.addEventListener('blur', validateField(element));
    } else {
      element.setAttribute('required', 'required');
      element.addEventListener('invalid', validateField(element));
      element.addEventListener('change', validateField(element));
      currentElement.addEventListener('blur', validateField(element));
    }
  }

  function clearBirthdayFields(): void {
    if (!birthdayDaySelect || !birthdayMonthSelect) {
      return;
    }

    birthdayMonthSelect.value = '';
    birthdayDaySelect.value = '';
    toggleRequired(birthdayMonthSelect, birthdayDaySelect, true);
    toggleRequired(birthdayDaySelect, birthdayMonthSelect, true);
    clearDisabledState(dayOptionsElm);
    clearDisabledState(monthOptionsElm);
  }

  function createAnimation(container: HTMLDivElement): { expand(): void; collapse(callback: () => void): void } {
    const animationSpeed = 150;

    let height = container.scrollHeight;

    container.style.overflow = `hidden`;
    container.style.transition = `height ${animationSpeed}ms ease, opacity ${animationSpeed}ms ease`;
    container.style.transitionDelay = `0ms, ${animationSpeed}ms`;

    function clearProps(): void {
      container.style.height = '';
      container.style.transitionDelay = `0s, ${animationSpeed}ms`;
      container.removeEventListener('transitionend', clearProps);
    }

    return {
      expand(): void {
        height = container.scrollHeight;
        container.style.height = '0px';
        container.style.opacity = '0';

        setTimeout(() => {
          container.style.height = `${height}px`;
          container.style.opacity = '1';
          container.addEventListener('transitionend', clearProps);
        });
      },
      collapse(callback): void {
        container.style.height = `${height}px`;

        setTimeout(() => {
          container.style.transitionDelay = `${animationSpeed}ms, 0ms`;
          container.style.height = '0px';
          container.style.opacity = '0';
        });

        setTimeout(() => {
          container.style.transitionDelay = `0ms, ${animationSpeed}ms`;
          callback();
        }, animationSpeed * 2);
      }
    };
  }
}

// TODO: could be moved in a more generic place
export function clearElement(node: HTMLElement | null | undefined): void {
  if (node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }
}
